import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Kick off essential analytics bootstrap as early as possible.
// Non-blocking — Sentry + UTM capture start in the background while React renders.
void import("./lib/observability").then(({ bootstrapEssential }) => bootstrapEssential());

createRoot(document.getElementById("root")!).render(<App />);
